import { render, staticRenderFns } from "./accountManageDetail.vue?vue&type=template&id=2f4962f6&scoped=true"
import script from "./accountManageDetail.vue?vue&type=script&lang=js"
export * from "./accountManageDetail.vue?vue&type=script&lang=js"
import style0 from "./accountManageDetail.vue?vue&type=style&index=0&id=2f4962f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4962f6",
  null
  
)

export default component.exports